"use client";

import { Camera, Clock, MapPin } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function PourquoiNousChoisir() {
  const {
    ref: ref1,
    isVisible: isVisible1
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref2,
    isVisible: isVisible2
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: ref3,
    isVisible: isVisible3
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const features = [{
    icon: Camera,
    title: "Expertise cinématographique",
    description: "Une maîtrise technique et artistique pour capturer chaque instant avec élégance et créativité.",
    ref: ref1,
    isVisible: isVisible1,
    delay: "0ms"
  }, {
    icon: Clock,
    title: "Réactivité et professionnalisme",
    description: "Des délais respectés et une communication transparente tout au long de votre projet.",
    ref: ref2,
    isVisible: isVisible2,
    delay: "100ms"
  }, {
    icon: MapPin,
    title: "Connaissance locale",
    description: "Basés à Montréal, nous connaissons les meilleurs lieux et événements pour sublimer vos moments.",
    ref: ref3,
    isVisible: isVisible3,
    delay: "200ms"
  }];
  return <section className="bg-light-background py-16 px-6 md:px-12 lg:px-24">
      <div className="container mx-auto">
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center text-foreground-light mb-12">
          Pourquoi nous choisir
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature, i) => {
          const Icon = feature.icon;
          return <div key={i} data-index={i} ref={feature.ref} style={{
            opacity: feature.isVisible ? 1 : 0,
            transform: feature.isVisible ? "translateY(0)" : "translateY(20px)",
            transition: `opacity var(--duration-medium) var(--ease-smooth) ${feature.delay}, transform var(--duration-medium) var(--ease-smooth) ${feature.delay}`
          }} className="group flex flex-col items-center text-center p-8 rounded-lg bg-background border border-border hover:shadow-medium hover:-translate-y-1 transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)]">
                <div className="mb-6 text-primary group-hover:text-accent transition-colors duration-[var(--duration-medium)]">
                  <Icon className="w-16 h-16" strokeWidth={1.5} />
                </div>
                
                <h3 className="font-display text-xl font-semibold text-foreground-light mb-3">
                  {feature.title}
                </h3>
                
                <p className="text-muted-foreground text-sm leading-relaxed">
                  {feature.description}
                </p>
              </div>;
        })}
        </div>
      </div>
    </section>;
}